// extracted by mini-css-extract-plugin
module.exports = {"popup":"_3CiY_Kai-nvBzzJLBGkWw3"};